<div class="flex items-center gap-2 p-2 text-xs uppercase opacity-50">
  <div class="h-px flex-grow bg-neutral-400 opacity-25"></div>
  <p><slot /></p>
  <div class="h-px flex-grow bg-neutral-400 opacity-25"></div>
</div>
